module.exports = __webpack_public_path__ + "img/EMT-GBM_10X_TPCP.3dc43a82.png";